import React from 'react';
import { Link } from 'react-router-dom';
import { FaMapMarkerAlt, FaWhatsapp, FaEnvelope, FaInstagram } from 'react-icons/fa';
import './Footer.css';
import logoPascolo from '../assets/pascolo-verde.png'; // Reutilizamos el logo de la Navbar

const Footer = () => {
  return (
    <footer className="footer-container">
      <div className="footer-content">
        
        {/* Columna 1: Marca y breve descripción */}
        <div className="footer-section brand-section">
          <img src={logoPascolo} alt="Pascolo" className="footer-logo" />
          <p>
            Quesos de tambo propio elaborados con pasión y tradición. 
            Del campo directamente a tu mesa.
          </p>
        </div>

        {/* Columna 2: Enlaces Rápidos */}
        <div className="footer-section links-section">
          <h3>Navegación</h3>
          <ul>
            <li><Link to="/">Inicio</Link></li>
            <li><Link to="/productos">Nuestros Quesos</Link></li>
            <li><Link to="/quienes-somos">Quiénes Somos</Link></li>
            <li><Link to="/como-producimos">Cómo Producimos</Link></li>
            <li><Link to="/admin">Dashboard de Administrador</Link></li>
          </ul>
        </div>

        {/* Columna 3: Datos de Contacto */}
        <div className="footer-section contact-section">
          <h3>Contacto</h3>
          <ul>
            <li>
              <FaMapMarkerAlt className="footer-icon" />
              <span>Cinco Saltos, Río Negro, Argentina</span>
            </li>
            <li>
              <FaWhatsapp className="footer-icon" />
              <span>+54 9 299 625 8300</span>
            </li>
            <li>
              <FaEnvelope className="footer-icon" />
              <span>pascoloquesos@gmail.com</span>
            </li>
          </ul>
          
          {/* Redes Sociales */}
          <div className="social-links">
            <a href="https://instagram.com/pascolopatagonia" target="_blank" rel="noopener noreferrer" aria-label="Instagram">
              <FaInstagram />
            </a>
          </div>
        </div>

      </div>

      {/* Franja inferior de Copyright */}
      <div className="footer-bottom">
        <p>&copy; {new Date().getFullYear()} Páscolo. Todos los derechos reservados.</p>
        <ul>
          <li><Link to="/terminos-y-condiciones">Términos y Condiciones</Link></li>
          <li><Link to="/politica-de-privacidad">Política de Privacidad</Link></li>
        </ul>
      </div>
    </footer>
  );
};

export default Footer;